<template>
  <Layout>
    <PageHeader :title="$t('module.esgDocument')" :items="breadcrumbs" />
    <div class="card">
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-lg-4">
            <b-input-group>
              <b-form-input
                v-model.trim="searchText"
                type="search"
                :placeholder="$t('label.search')"
                @keyup.enter="applySearch"
              />
              <b-input-group-append>
                <b-button
                  variant="info"
                  :aria-label="$t('label.search')"
                  @click="applySearch"
                >
                  <i class="mdi mdi-magnify"></i>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
        </div>
        <div v-if="!status.list" class="d-flex justify-content-center p-5">
          <b-spinner variant="info" />
        </div>
        <b-alert v-else-if="listError" show variant="danger">
          {{ $t("label.esgDocumentLoadError") }}
          <b-button size="sm" variant="outline-danger" @click="loadDocuments">
            {{ $t("label.retryPermissionDefinitions") }}
          </b-button>
        </b-alert>
        <template v-else>
          <b-table
            :items="list.data"
            :fields="fields"
            primary-key="uuid"
            show-empty
            responsive
          >
            <template #cell(actions)="{ item }">
              <b-button
                variant="info"
                size="sm"
                :to="{
                  name: 'EsgDocumentUsers',
                  params: { documentUUID: item.uuid },
                }"
              >
                <i class="mdi mdi-account-multiple-outline mr-1"></i>
                {{ $t("label.viewSubmission") }}
              </b-button>
            </template>
          </b-table>
          <div
            v-if="list.pagination.total"
            class="d-flex flex-wrap justify-content-between align-items-center mt-3"
          >
            <small class="text-muted">{{
              $tc("label.results", list.pagination.total, [
                list.pagination.total,
              ])
            }}</small>
            <b-pagination
              v-model="currentPage"
              :total-rows="list.pagination.total"
              :per-page="searchCriteria.pageSize"
              class="mb-0"
              @change="pageNavigation"
            />
          </div>
        </template>
      </div>
    </div>
  </Layout>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import {
  ESG_DOCUMENT_MODULE,
  GET_ALL_ESG_DOCUMENT,
} from "@/state/api/esgDocument.state";

export default {
  name: "EsgDocumentListing",
  page: { title: i18n.t("module.esgDocument") },
  components: { Layout, PageHeader },
  data() {
    return {
      searchText: "",
      currentPage: 1,
      searchCriteria: { pageNumber: 1, pageSize: 15, searchArray: [] },
      breadcrumbs: [
        { text: i18n.t("module.administration"), href: "/administrations" },
        { text: i18n.t("module.esgDocument"), active: true },
      ],
      fields: [
        { key: "name", label: i18n.t("label.name") },
        { key: "description", label: i18n.t("label.description") },
        { key: "version", label: i18n.t("label.version") },
        { key: "actions", label: i18n.t("label.action") },
      ],
    };
  },
  computed: {
    ...mapState(ESG_DOCUMENT_MODULE, ["list", "status", "listError"]),
  },
  created() {
    this.loadDocuments();
  },
  methods: {
    ...mapActions(ESG_DOCUMENT_MODULE, [GET_ALL_ESG_DOCUMENT]),
    loadDocuments() {
      return this.getAllEsgDocument({ filter: this.searchCriteria });
    },
    applySearch() {
      this.currentPage = 1;
      this.searchCriteria = {
        ...this.searchCriteria,
        pageNumber: 1,
        searchArray: this.searchText ? [this.searchText] : [],
      };
      this.loadDocuments();
    },
    pageNavigation(pageNumber) {
      this.currentPage = pageNumber;
      this.searchCriteria = { ...this.searchCriteria, pageNumber };
      this.loadDocuments();
    },
  },
};
</script>
